// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1480be42f78b1a84bcad","293":"32bdca6edd3208138de6","518":"1b4f4b180e141f5fe579","779":"8bc03cdce726e54b26c5"}[chunkId] + ".js";
};